

export const selectOriginsList = (state) =>  state.origins.origins;
export const selectOriginsLoading = (state) => state.origins.loading;
export const selectOriginsError = (state) => state.origins.error;
export const selectOriginsSuccessMessage = (state) => state.origins.successMessage;
